import { ReactNode, useContext, useEffect, useRef, useState } from 'react';
import Carousel from 'react-material-ui-carousel';

import { DataContext } from 'providers/data';

import { Box, Typography, AccordionSummary, AccordionDetails, Fade } from '@mui/material';

import Modals from 'components/views/Modals';
import AccessData from './TopicsEdit/AccessData';
import GeneralData from './TopicsEdit/GeneralData';
import ModalClube from 'components/views/ModalClube';
import PhoneContact from './TopicsEdit/PhoneContact';
import { Banner } from 'components/views/ContainersPage';
import BillingAddress from './TopicsEdit/BillingAddress';
import FadeAnimation from 'components/views/FadeAnimation';
import EmergencyContact from './TopicsEdit/EmergencyContact';
import { ButtonRectangle } from 'components/views/form/Button';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { AccordionCustom } from './styles';

import bannerClub2 from 'assets/images/banners/mob/banner-club2-mob.png';
import bannerUpgrade from 'assets/images/banners/mob/banner-upgrade-mob.png';
import bannerServicesAdd from 'assets/images/banners/mob/banner-services-add-mob.png';
import BannerDadosAtualizadosMob from 'assets/images/banners/mob/banner-dados-atualizados-mob.png';

type ParamsAccordion = {
    id?: string;
    title: string;
    children: ReactNode;
    showDataSave: boolean;
}

const Accordion = ({ id = '', title, children, showDataSave }: ParamsAccordion) => {
    const accordionRef = useRef<HTMLDivElement>(null);

    const handleScrollCenter = () => {
        const boxMain = document?.getElementById('box-main');
        const reference = accordionRef?.current?.classList.contains('Mui-expanded');

        setTimeout(() => {
            const target = document?.getElementById(id) as HTMLElement;

            if (target && boxMain && !reference) {
                boxMain.scrollTop = target.offsetTop - 10;
            }
        }, 600);
    }


    return (
        <AccordionCustom ref={accordionRef} id={id} onClick={() => handleScrollCenter()}>
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                <Typography fontSize='1.25rem' fontWeight={600} sx={{ padding: '2px 0 4px .6rem', }}>
                    {title}
                </Typography>
                <Box sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                }}>
                    <Fade in={showDataSave}>
                        <Box sx={{ display: 'flex', width: '100%', height: '100%', alignItems: 'flex-end' }}>
                            <Typography
                                fontSize='.875rem'
                                fontWeight={600}
                                color='white'
                                sx={{
                                    position: 'absolute',
                                    right: '17%',
                                    width: '10.125rem',
                                    borderRadius: '5px 5px 0 0',
                                    backgroundColor: 'primary.main',
                                    padding: '.8rem 2.25rem .25rem',
                                    zIndex: 2
                                }}
                            >
                                Dados salvos!
                            </Typography>
                            <Box sx={{ width: '100%', height: '100%', backgroundColor: 'secondary.main', zIndex: 1 }} />
                        </Box>
                    </Fade>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{
                width: '100%',
                display: 'flex',
                padding: {
                    xs: '1.5625rem 0 0',
                    md: '1.8175rem 3rem .32rem 0'
                },
                justifyContent: 'center',
            }}>
                {children}
            </AccordionDetails>
        </AccordionCustom >
    );
}

const RegistrationData = () => {
    const [showError, setShowError] = useState(false);
    const [existDetails, setExistDetails] = useState(false);
    const [showModalClube, setShowModalClube] = useState(false);
    const [showUpdatePerfil, setShowUpdatePerfil] = useState(false);
    const { updatePerfil, dataCustomerForEdit, dataRelationship, blockClick, selectedCar, handleGetRelationship } = useContext(DataContext);

    useEffect(() => {
        (!dataRelationship || (dataRelationship?.length === 0)) && handleGetRelationship({ token: localStorage.getItem('token')! });

        if (dataCustomerForEdit && dataRelationship && dataRelationship?.length > 0) {

            setExistDetails(true);
        } else {
            setExistDetails(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit, dataRelationship]);

    useEffect(() => {
        if (updatePerfil?.type !== 'default') {
            if (updatePerfil?.result === false) {
                setShowError(true);
            } else if (updatePerfil?.result === true) {
                setShowUpdatePerfil(true);
                setTimeout(() => {
                    setShowUpdatePerfil(false);
                }, 2000);
            }
        }
    }, [updatePerfil]);

    return (
        <FadeAnimation>
            <Box>
                <Typography fontWeight={600} fontSize='.875rem' marginBottom='2.125rem'>
                    As alterações cadastrais efetuadas não refletem nos dados de seu perfil.
                </Typography>
                {existDetails &&
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2.8125rem' }}>
                        <Accordion id='dataGeneral' title='Dados gerais' showDataSave={showUpdatePerfil && (updatePerfil?.type === 'generalData')}>
                            <GeneralData dataCustomerForEdit={dataCustomerForEdit!} />
                        </Accordion>
                        <Accordion id='accessData' title='Dados de acesso' showDataSave={showUpdatePerfil && (updatePerfil?.type === 'accessData')}>
                            <AccessData dataCustomerForEdit={dataCustomerForEdit!} />
                        </Accordion>
                        <Accordion id='phonesContact' title='Telefones' showDataSave={showUpdatePerfil && (updatePerfil?.type === 'phoneContact')}>
                            <PhoneContact dataCustomerForEdit={dataCustomerForEdit!} />
                        </Accordion>
                        <Accordion id='billingAddress' title='Endereço de Cobrança / Faturamento' showDataSave={showUpdatePerfil && (updatePerfil?.type === 'billingAddress')}>
                            <BillingAddress dataCustomerForEdit={dataCustomerForEdit!} />
                        </Accordion>
                        <Accordion id='emergencyData' title='Dados de emergência' showDataSave={showUpdatePerfil && (updatePerfil?.type === 'emergencyContact')}>
                            <EmergencyContact dataCustomerForEdit={dataCustomerForEdit!} />
                        </Accordion>
                        <Box sx={{ display: { xs: 'block', md: 'none' }, marginTop: '-.5rem' }}>
                            {selectedCar?.COMODATO ?
                                [1079756].indexOf(selectedCar?.CODIGO_SEGURADORA) >= 0 ?
                                    <Carousel sx={{ width: '100%', 'button': { display: 'none' }, minHeight: '10rem' }}>
                                        <Banner bannerImg={bannerClub2} link='' onClick={() => setShowModalClube(true)} />
                                        <Banner bannerImg={BannerDadosAtualizadosMob} link='/meus-dados' />
                                    </Carousel>
                                    :
                                    <Banner bannerImg={BannerDadosAtualizadosMob} link='/meus-dados' />
                                :
                                <Carousel sx={{ width: '100%', 'button': { display: 'none' }, minHeight: '10rem' }}>
                                    <Banner bannerImg={bannerUpgrade} link={!blockClick ? '/central-de-trocas' : ''} />
                                    <Banner bannerImg={bannerClub2} link='' onClick={() => setShowModalClube(true)} />
                                    <Banner bannerImg={bannerServicesAdd} link='/servicos-adicionais' />
                                    <Banner bannerImg={BannerDadosAtualizadosMob} link='/meus-dados' />
                                </Carousel>
                            }
                        </Box>
                    </Box>
                }

                <Modals open={showError}>
                    <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '20rem' } }}>
                        <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1.375rem 1.25rem'>
                            <Typography fontSize='1rem' fontWeight={700} lineHeight='20px'>
                                Não foi possível concluir o <br />processo no momento.
                            </Typography>
                            <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                                {updatePerfil?.error_msg ? updatePerfil.error_msg : 'Tente novamente mais tarde.'}
                            </Typography>
                        </Box>

                        <Box sx={{
                            backgroundColor: 'primary.main',
                            borderRadius: '0 0 8px 8px',
                            padding: {
                                xs: '1rem 2.5rem 1.625rem',
                                md: '1.875rem 2rem 1.625rem'
                            },
                            'button': {
                                width: '12.5rem',
                                height: '2.5rem'
                            }
                        }}>
                            <ButtonRectangle name='Fechar' onClick={() => setShowError(false)} />
                        </Box>
                    </Box>
                </Modals>

                <ModalClube openModal={showModalClube} handleClickClosed={() => setShowModalClube(false)} />
            </Box>
        </FadeAnimation>
    );
}

export default RegistrationData;